module.exports = __webpack_public_path__ + "assets/img/4.589e9733.png";